"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _UserRoleAssignments = _interopRequireDefault(require("./UserRoleAssignments"));
var _table = _interopRequireDefault(require("../../../core/table"));
var _existingUserCheck = _interopRequireDefault(require("../../../core/existing-user-check"));
var _editableField = _interopRequireDefault(require("../../../core/editable-field"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  newRoleHolder: {
    email: null,
    isAdmin: false,
    isCalendarOfficer: false,
    isSafetyOfficer: false,
    hasStatsAccess: false
  }
};
var _ref = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null, "Email"), /*#__PURE__*/_react.default.createElement("th", null, "Name"), /*#__PURE__*/_react.default.createElement("th", null, "LastLogin"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center"
}, "System Admin"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center"
}, "Calendar Officer"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center"
}, "Safety Officer"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center"
}, "Stats Access")));
var _ref2 = /*#__PURE__*/_react.default.createElement("td", null);
class UserRoles extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_setValue", (value, field) => {
      this.setState({
        newRoleHolder: {
          ...this.state.newRoleHolder,
          [field]: value
        }
      });
      if (field !== 'email' && value) {
        this.props.assignNewRoleHolder(this.state.newRoleHolder.email, field);
        this.setState(initialState);
      }
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_table.default, null, _ref, /*#__PURE__*/_react.default.createElement("tbody", null, this.props.usersWithRoles.map(u => /*#__PURE__*/_react.default.createElement(_UserRoleAssignments.default, {
      key: u.id,
      userWithRole: u
    })), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      type: "email",
      name: "email",
      value: this.state.newRoleHolder.email || 'ADD EMAIL',
      onChange: this._setValue,
      required: true
    })), _ref2, /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_existingUserCheck.default, {
      userEmail: this.state.newRoleHolder.email
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-center"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      type: "Checkbox",
      enabled: !!this.state.newRoleHolder.email,
      name: "isAdmin",
      checked: this.state.newRoleHolder.isAdmin,
      onChange: this._setValue
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-center"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      type: "Checkbox",
      enabled: !!this.state.newRoleHolder.email,
      name: "isCalendarOfficer",
      checked: this.state.newRoleHolder.isCalendarOfficer,
      onChange: this._setValue
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-center"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      type: "Checkbox",
      enabled: !!this.state.newRoleHolder.email,
      name: "isSafetyOfficer",
      checked: this.state.newRoleHolder.isSafetyOfficer,
      onChange: this._setValue
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-center"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      type: "Checkbox",
      enabled: !!this.state.newRoleHolder.email,
      name: "hasStatsAccess",
      checked: this.state.newRoleHolder.hasStatsAccess,
      onChange: this._setValue
    })))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref3 = {
  usersWithRoles: _mergeBqlQueries({
    id: true
  }, _UserRoleAssignments.default.partialQueries.UsersWithRoles)
};
var _default = exports.default = (0, _reactBicycle.connect)(UserRoles, props => _ref3, (client, props) => ({
  assignNewRoleHolder(email, role) {
    return client.update('User.assignNewRoleHolder', {
      email,
      role
    });
  }
}));